var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import h from "../helper/helper";
var validator = require("validation/validator");
import SecuredDataApi, { SecuredData } from "../asset/securedDataWithMetaData";
import * as Bluebird from "bluebird";
import ObjectLoader from "../services/cachedObjectLoader";
import Observer from '../asset/observer';
var PROFILE_SECUREDDATA_OPTIONS = {
    type: "profile",
    removeEmpty: true,
    encryptDepth: 1
};
var Profile = /** @class */ (function (_super) {
    __extends(Profile, _super);
    function Profile(data, options) {
        var _this = _super.call(this) || this;
        _this.checkProfile = function () {
            var err = validator.validate("profile", _this.securedData.contentGet());
            if (err) {
                throw err;
            }
        };
        _this.getID = function () {
            if (!_this.id) {
                return;
            }
            return _this.isPublicProfile ? "public-" + _this.id : "private-" + _this.id;
        };
        _this.sign = function (signKey, cb) {
            if (!_this.isPublicProfile) {
                throw new Error("please encrypt private profiles!");
            }
            return _this.securedData.sign(signKey).then(function (signedMeta) {
                return {
                    content: _this.securedData.contentGet(),
                    meta: signedMeta
                };
            }).nodeify(cb);
        };
        _this.signAndEncrypt = function (signKey, cryptKey) {
            if (_this.isPublicProfile) {
                throw new Error("no encrypt for public profiles!");
            }
            return _this.securedData.signAndEncrypt(signKey, cryptKey);
        };
        _this.updated = function () {
            return _this.securedData.updated();
        };
        _this.changed = function () {
            return _this.securedData.isChanged();
        };
        _this.setFullProfile = function (data) {
            _this.securedData.contentSet(data);
        };
        _this.setAttribute = function (attr, value) {
            _this.securedData.contentSetAttr(attr, value);
            return Bluebird.resolve();
        };
        _this.removeAttribute = function (attr) {
            _this.securedData.contentRemoveAttr(attr);
        };
        _this.getFull = function () {
            return _this.securedData.contentGet();
        };
        _this.getAttribute = function (attrs) {
            return h.deepGet(_this.securedData.contentGet(), attrs);
        };
        options = options || {};
        _this.isPublicProfile = options.isPublicProfile === true;
        _this.securedData = new SecuredData(data.content, data.meta, PROFILE_SECUREDDATA_OPTIONS, true);
        _this.checkProfile();
        if (data.profileid) {
            _this.id = data.profileid;
        }
        return _this;
    }
    return Profile;
}(Observer));
export default Profile;
var ProfileLoader = /** @class */ (function (_super) {
    __extends(ProfileLoader, _super);
    function ProfileLoader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ProfileLoader;
}(ObjectLoader({
    cacheName: "profile",
    getID: function (_a) {
        var meta = _a.meta, signKey = _a.signKey;
        return signKey + "-" + meta._signature;
    },
    download: function () { throw new Error("profile get by id is not implemented"); },
    load: function (_a) {
        var content = _a.content, meta = _a.meta, isPublic = _a.isPublic, signKey = _a.signKey;
        var securedData = isPublic ?
            new SecuredData(content, meta, PROFILE_SECUREDDATA_OPTIONS, true) :
            SecuredDataApi.load(content, meta, PROFILE_SECUREDDATA_OPTIONS);
        return Bluebird.all([
            securedData.verifyAsync(signKey),
            isPublic ? null : securedData.decrypt()
        ]).then(function () { return ({
            profile: {
                content: securedData.contentGet(),
                meta: securedData.metaGet(),
            },
            options: {
                signKey: signKey,
                isPublic: isPublic
            }
        }); });
    },
    restore: function (_a) {
        var profile = _a.profile, options = _a.options;
        return new Profile(profile, options);
    }
})));
export { ProfileLoader };



//////////////////
// WEBPACK FOOTER
// ./js/users/profile.ts
// module id = YX39
// module chunks = 1 2 3